export default __webpack_public_path__ + "locales/ar-SA/SMTPSettings.json?hash=5278f8c5df58d70ed5cfc15b279ca879";